import { useEffect, useRef } from 'react';
import PropTypes from 'prop-types';

const AlwaysScrollToBottom = ({ listener = null }) => {
  const elementRef = useRef();
  useEffect(() => {
    elementRef.current.scrollIntoView();
  }, [listener]);
  return <div ref={elementRef} />;
};

AlwaysScrollToBottom.propTypes = {
  listener: PropTypes.instanceOf(Object),
};

export default AlwaysScrollToBottom;
